import axios from 'axios';
import { toast } from 'react-toastify';

import { store } from '../app';
import { startLogout } from '../redux/reducers/auth';
import { history } from '../routers/AppRouter';

// CREATE INSTANCE
const axiosInstance = axios.create();
axiosInstance.defaults.withCredentials = true;


// RESPONSE INTERCEPTOR
axiosInstance.interceptors.response.use((response) => response, (error) => {
  const { status } = error.response;

  if (status === 401) {
    const { isLoggedIn } = store.getState().auth;
    if (isLoggedIn) toast.warn('Something is wrong. Please log back in.');
    store.dispatch(startLogout());
    history.push('/login');
  }

  // The API will return a 403 if an Admin tries to access an Applicant which they do not have permission to access
  if (status === 403 && error.response.data.message === 'Applicant Inaccessible') {
    history.push('/not-found');
  }

  if (status === 498) {
    const originalRequest = error.config;
    return new Promise((resolve, reject) => {
      // Hit the /refresh/access-token route for new accessToken
      axiosInstance.get(`${baseURL}/refresh/access-token`)
        .then(() => {
          axios(originalRequest)
            .then((respo) => resolve(respo))
            .catch((err) => {
              if (err.response.status === 401) {
                const { isLoggedIn } = store.getState().auth;
                if (isLoggedIn) toast.warn('Something is wrong. Please log back in.');
                store.dispatch(startLogout());
                history.push('/login');
              }
            });
        })
        .catch((err) => {
          console.error(err);
          return reject(err);
        });
    });
  }

  return Promise.reject(error);
});


export default axiosInstance;
